export const initialState = {
  fetched: false,
  qna_stack: [],
  qna_hash: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'ONBOARDING_FETCHED':
      return {
        ...state,
        fetched: true,
        ...action.payload,
      };
    case 'ADD_FRAME_AND_KEYS':
      let newStack = state.qna_stack.slice();
      // add the list of reviewed keys to the stack
      newStack.push({ keys: Object.keys(action.frame), review: false });
      return {
        ...state,
        qna_stack: newStack,
        // merge the k-v pairs into the hash
        qna_hash: {
          ...state.qna_hash,
          ...action.frame,
        },
      };
    case 'POP_REVIEW_FRAMES_AND_REMOVE_KEYS':
      // find out which keys need to be removed from hash
      let removeKeys = [];
      state.qna_stack.slice(action.index, state.qna_stack.length).forEach(frame => {
        removeKeys = removeKeys.concat(frame.keys);
      });
      // generate the new hash by excluding those no longer needed
      let newHash = {};
      Object.entries(state.qna_hash).forEach(([key, value]) => {
        if (!removeKeys.includes(key)) {
          newHash[key] = value;
        }
      });
      return {
        ...state,
        // only keep the frames that are not in review status
        qna_stack: state.qna_stack.slice(0, action.index),
        qna_hash: newHash,
      };
    case 'SET_REVIEW_ON_INDEX':
      return {
        ...state,
        qna_stack: state.qna_stack.map((frame, i) => (i === action.index ? { ...frame, review: action.value } : frame)),
      };
    case 'MARK_FRAMES_FROM_TO':
      const first = state.qna_stack.slice(0, action.fromIndex);
      const second = state.qna_stack.slice(action.fromIndex, action.toIndex).map(frame => ({
        ...frame,
        review: action.value,
      }));
      const third = state.qna_stack.slice(action.toIndex);

      return {
        ...state,
        qna_stack: first.concat(second).concat(third),
      };
    default:
      return state;
  }
}
